import { StyledContainer } from "@components/Styled/Container";
import tw from "twin.macro";

export const Container = tw(StyledContainer)`
  relative flex flex-wrap mx-auto md:px-maxi xl:px-tera md:max-w-2xl
`;
export const Content = tw.div`
  w-full px-midi z-10 md:mx-auto md:w-4/10 md:px-maxi md:pr-0 md:pt-micro md:pb-midi 2xl:px-tera 2xl:pr-0
`;
export const Desktop = tw.div`
  hidden md:block
`;
export const Mobile = tw.div`
  block md:hidden
`;
export const Sticky = tw.div`
  w-full md:w-6/10 md:sticky md:top-[180px] md:self-start xl:w-5/10
`;
export const Title = tw.h1`
  text-h3 leading-h1 font-display
`;
export const TitleWrapper = tw.div`
  flex justify-between items-start xl:items-center
`;
